import { BaseRequest, IBaseRequest } from "../../BaseRequest";

export interface IContact {
  content?: string;
  description?: string;
  isMain?: boolean;
  isPrimary?: boolean;
  type?: string;
  typeName?: string;
  typeType?: string;
  category?: string;
}

export interface IRow {
  id?: string;
}

export interface ICol {
  name?: string;
  desc?: string;
}

export interface IFolderType {
  value?: string;
}

export interface IGetContactListRequest extends IBaseRequest {
  timestamp?: string;
  offset?: number;
  limit?: number;
  treeHandle?: string;
  person?: string;
  company?: string;
  industry?: string;
  department?: string;
  position?: string;
  type?: string;
  onlyIds?: boolean;
  organizationId?: string;
  hasFolder?: boolean;
  showOnlyUc?: boolean;
  name1?: string;
  name2?: string;
  name3?: string;
  RegNumber?: string;
  VATNumber?: string;
  keyId?: string;
  contains?: string;
  hideRelations?: boolean;
  hideFolders?: boolean;
  distributionGroup?: string;
  project?: string;
  showRelated?: boolean;
  contactContact?: string;
  onlyUser?: boolean;
  accessFilter?: string;
  onlyGarant?: boolean;
  onlyAvailable?: boolean;
  availableFrom?: string;
  availableTo?: string;
  taskType?: string;
  notSimilarName?: string;
  viewId?: string;
  workContract?: string;
  region?: string;
  city?: string;
  zip?: string;
  agemin?: number;
  agemax?: number;
  gender?: string;
  countOnly?: boolean;
  folderStatus?: string;
  conjuctionDistrGroups?: string;
  showPersonInfo?: boolean;
  consentStatus?: string;
  consentNote?: string;
  anonymized?: string;
  validFromMin?: string;
  validFromMax?: string;
  validToMin?: string;
  validToMax?: string;
  fpaTypeCategory?: string;
  category?: string;
  externalSystem?: string;
  externalId?: string;
  ORDER?: {
    COL?: ICol[];
  };
  FOLDERTYPE?: IFolderType[];
  CONTACTS?: {
    CONTACT?: IContact[];
  };
  DISTRGROUPS?: {
    ROW?: IRow[];
  };
  USERS?: {
    ID?: string[];
  };
}

export class GetContactListRequest extends BaseRequest implements IGetContactListRequest {
  timestamp?: string;
  offset?: number;
  limit?: number;
  treeHandle?: string;
  person?: string;
  company?: string;
  industry?: string;
  department?: string;
  position?: string;
  type?: string;
  onlyIds?: boolean;
  organizationId?: string;
  hasFolder?: boolean;
  showOnlyUc?: boolean;
  name1?: string;
  name2?: string;
  name3?: string;
  RegNumber?: string;
  VATNumber?: string;
  keyId?: string;
  contains?: string;
  hideRelations?: boolean;
  hideFolders?: boolean;
  distributionGroup?: string;
  project?: string;
  showRelated?: boolean;
  contactContact?: string;
  onlyUser?: boolean;
  accessFilter?: string;
  onlyGarant?: boolean;
  onlyAvailable?: boolean;
  availableFrom?: string;
  availableTo?: string;
  taskType?: string;
  notSimilarName?: string;
    viewId?: string;
  workContract?: string;
  region?: string;
  city?: string;
  zip?: string;
  agemin?: number;
  agemax?: number;
  gender?: string;
  countOnly?: boolean;
  folderStatus?: string;
  conjuctionDistrGroups?: string;
  showPersonInfo?: boolean;
  consentStatus?: string;
  consentNote?: string;
  anonymized?: string;
  validFromMin?: string;
  validFromMax?: string;
  validToMin?: string;
  validToMax?: string;
  fpaTypeCategory?: string;
  category?: string;
  externalSystem?: string;
  externalId?: string;
  ORDER?: {
    COL?: ICol[];
  };
  FOLDERTYPE?: IFolderType[];
  CONTACTS?: {
    CONTACT?: IContact[];
  };
  DISTRGROUPS?: {
    ROW?: IRow[];
  };
  USERS?: {
    ID?: string[];
  };
  constructor(_server: string, _session: string, otherOptions: any){
      super(_server, _session);
      this.timestamp = otherOptions?.timestamp;
      this.offset = otherOptions?.offset;
      this.limit = otherOptions?.limit;
      this.treeHandle = otherOptions?.treeHandle;
      this.person = otherOptions?.person;
      this.company = otherOptions?.company;
      this.industry = otherOptions?.industry;
      this.department = otherOptions?.department;
      this.position = otherOptions?.position;
      this.type = otherOptions?.type;
      this.onlyIds = otherOptions?.onlyIds;
      this.organizationId = otherOptions?.organizationId;
      this.hasFolder = otherOptions?.hasFolder;
      this.showOnlyUc = otherOptions?.showOnlyUc;
      this.name1 = otherOptions?.name1;
      this.name2 = otherOptions?.name2;
      this.name3 = otherOptions?.name3;
      this.RegNumber = otherOptions?.RegNumber;
      this.VATNumber = otherOptions?.VATNumber;
      this.keyId = otherOptions?.keyId;
      this.contains = otherOptions?.contains;
      this.hideRelations = otherOptions?.hideRelations;
      this.hideFolders = otherOptions?.hideFolders;
      this.distributionGroup = otherOptions?.distributionGroup;
      this.project = otherOptions?.project;
      this.showRelated = otherOptions?.showRelated;
      this.contactContact = otherOptions?.contactContact;
      this.onlyUser = otherOptions?.onlyUser;
      this.accessFilter = otherOptions?.accessFilter;
      this.onlyGarant = otherOptions?.onlyGarant;
      this.onlyAvailable = otherOptions?.onlyAvailable;
      this.availableFrom = otherOptions?.availableFrom;
      this.availableTo = otherOptions?.availableTo;
      this.taskType = otherOptions?.taskType;
      this.notSimilarName = otherOptions?.notSimilarName;
      this.viewId = otherOptions?.viewId;
      this.workContract = otherOptions?.workContract;
      this.region = otherOptions?.region;
      this.city = otherOptions?.city;
      this.zip = otherOptions?.zip;
      this.agemin = otherOptions?.agemin;
      this.agemax = otherOptions?.agem
      this.countOnly = otherOptions?.countOnly;
      this.folderStatus = otherOptions?.folderStatus;
      this.conjuctionDistrGroups = otherOptions?.conjuctionDistrGroups;
      this.showPersonInfo = otherOptions?.showPersonInfo;
      this.consentStatus = otherOptions?.consentStatus;
      this.consentNote = otherOptions?.consentNote;
      this.anonymized = otherOptions?.anonymized;
      this.validFromMin = otherOptions?.validFromMin;
      this.validFromMax = otherOptions?.validFromMax;
      this.validToMin = otherOptions?.validToMin;
      this.validToMax = otherOptions?.validToMax;
      this.fpaTypeCategory = otherOptions?.fpaTypeCategory;
      this.category = otherOptions?.category;
      this.externalSystem = otherOptions?.externalSystem;
      this.externalId = otherOptions?.externalId;
      this.ORDER = otherOptions?.ORDER;
      this.FOLDERTYPE = otherOptions?.FOLDERTYPE;
      this.CONTACTS = otherOptions?.CONTACTS;
      this.DISTRGROUPS = otherOptions?.DISTRGROUPS;
      this.USERS = otherOptions?.USERS;
  }

  toXml(): string {
    var parameters: string = super.toXml();
    parameters += this.makeNode(this.timestamp, 'timestamp');
    parameters += this.makeNode(this.offset, 'offset');
    parameters += this.makeNode(this.limit, 'limit');
    parameters += this.makeNode(this.treeHandle, 'treeHandle');
    parameters += this.makeNode(this.person, 'person');
    parameters += this.makeNode(this.company, 'company');
    parameters += this.makeNode(this.industry, 'industry');
    parameters += this.makeNode(this.department, 'department');
    parameters += this.makeNode(this.position, 'position');
    parameters += this.makeNode(this.type, 'type');
    parameters += this.makeNode(this.onlyIds, 'onlyIds');
    parameters += this.makeNode(this.organizationId, 'organizationId');
    parameters += this.makeNode(this.hasFolder, 'hasFolder');
    parameters += this.makeNode(this.showOnlyUc, 'showOnlyUc');
    parameters += this.makeNode(this.name1, 'name1');
    parameters += this.makeNode(this.name2, 'name2');
    parameters += this.makeNode(this.name3, 'name3');
    parameters += this.makeNode(this.RegNumber, 'RegNumber');
    parameters += this.makeNode(this.VATNumber, 'VATNumber');
    parameters += this.makeNode(this.keyId, 'keyId');
    parameters += this.makeNode(this.contains, 'contains');
    parameters += this.makeNode(this.hideRelations, 'hideRelations');
    parameters += this.makeNode(this.hideFolders, 'hideFolders');
    parameters += this.makeNode(this.distributionGroup, 'distributionGroup');
    parameters += this.makeNode(this.project, 'project');
    parameters += this.makeNode(this.showRelated, 'showRelated');
    parameters += this.makeNode(this.contactContact, 'contactContact');
    parameters += this.makeNode(this.onlyUser, 'onlyUser');
    parameters += this.makeNode(this.accessFilter, 'accessFilter');
    parameters += this.makeNode(this.onlyGarant, 'onlyGarant');
    parameters += this.makeNode(this.onlyAvailable, 'onlyAvailable');
    parameters += this.makeNode(this.availableFrom, 'availableFrom');
    parameters += this.makeNode(this.availableTo, 'availableTo');
    parameters += this.makeNode(this.taskType, 'taskType');
    parameters += this.makeNode(this.notSimilarName, 'notSimilarName');
    parameters += this.makeNode(this.viewId, 'viewId');
    parameters += this.makeNode(this.workContract, 'workContract');
    parameters += this.makeNode(this.region, 'region');
    parameters += this.makeNode(this.city, 'city');
    parameters += this.makeNode(this.zip, 'zip');
    parameters += this.makeNode(this.agemin, 'agemin');
    parameters += this.makeNode(this.agemax, 'agemax');
    parameters += this.makeNode(this.gender, 'gender');
    parameters += this.makeNode(this.countOnly, 'countOnly');
    parameters += this.makeNode(this.folderStatus, 'folderStatus');
    parameters += this.makeNode(this.conjuctionDistrGroups, 'conjuctionDistrGroups');
    parameters += this.makeNode(this.showPersonInfo, 'showPersonInfo');
    parameters += this.makeNode(this.consentStatus, 'consentStatus');
    parameters += this.makeNode(this.consentNote, 'consentNote');
    parameters += this.makeNode(this.anonymized, 'anonymized');
    parameters += this.makeNode(this.validFromMin, 'validFromMin');
    parameters += this.makeNode(this.validFromMax, 'validFromMax');
    parameters += this.makeNode(this.validToMin, 'validToMin');
    parameters += this.makeNode(this.validToMax, 'validToMax');
    parameters += this.makeNode(this.fpaTypeCategory, 'fpaTypeCategory');
    parameters += this.makeNode(this.category, 'category');
    parameters += this.makeNode(this.externalSystem, 'externalSystem');
    parameters += this.makeNode(this.externalId, 'externalId');
    parameters += this.ORDER ? `<ORDER>${this.ORDER?.COL?.map((col) => `<COL><name>${col.name}</name><desc>${col.desc}</desc></COL>`).join('')}</ORDER>` : '';
    parameters += this.FOLDERTYPE ? `<FOLDERTYPE>${this.FOLDERTYPE?.map((folderType) => `<value>${folderType.value}</value>`).join('')}</FOLDERTYPE>` : '';
    parameters += this.CONTACTS ? `<CONTACTS>${this.CONTACTS?.CONTACT?.map((contact) => `<CONTACT><content>${contact.content}</content><description>${contact.description}</description><isMain>${contact.isMain}</isMain><isPrimary>${contact.isPrimary}</isPrimary><type>${contact.type}</type><typeName>${contact.typeName}</typeName><typeType>${contact.typeType}</typeType><category>${contact.category}</category></CONTACT>`).join('')}</CONTACTS>` : '';
    parameters += this.DISTRGROUPS ? `<DISTRGROUPS>${this.DISTRGROUPS?.ROW?.map((row) => `<ROW><id>${row.id}</id></ROW>`).join('')}</DISTRGROUPS>` : '';
    parameters += this.USERS ? `<USERS>${this.USERS?.ID?.map((id) => `<ID>${id}</ID>`).join('')}</USERS>` : '';

    return super.wrapperXml("GetContactList", parameters);
  }
}


